import { gql } from '@apollo/client'

export const IS_TOKEN_VALID_QUERY = gql`
  query ($token: JwtToken!) {
    isTokenValid(token: $token)
  }
`
